import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=dcb70f32&"
import script from "./ButtonAction.vue?vue&type=script&lang=ts&"
export * from "./ButtonAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports